import AppListing from '../app-components/Listing/AppListing';
import Constants from "./../app-components/constant";

Vue.component('app-finances-report-listing', {
    mixins: [AppListing],
    props:{
        userOffice:{
            type: Object,
            default: ()=>({})
        },
        financialBalanceProp:{
            type: Object,
            default: ()=>({})
        },
        urlDownloadPayment:{
            type: String,
            default: null
        },
        allowedShowDetail:{
            type: Array,
            default: ()=>([])
        },
        financialBalances:{
            type: Object,
            default: () => {}
        },
        typeTransactions:{
            type: Object,
            default: () => {}
        },
    },
    data: function () {  
        return {
            showFilter: false,
            moduleFilters:{
                app_offices_id: null,
                app_factories_id: null,
                source_balance_id: null,
                // date_start: this.formatDate((new Date()), null, Constants.dateFormat.ymdhis),
                date_start: this.getDateFromString((new Date()), null, Constants.dateFormat.ymdhis, 'utc') ,
                // date_end: this.formatDate((new Date()), null, Constants.dateFormat.ymdhis),
                date_end: this.getDateFromString((new Date()), null, Constants.dateFormat.ymdhis, 'utc') ,
            },
            tempOffice: null,
            tempFactory: null,
            testDate: null,

            countResult: 0 ,
            calculated: {
                financial_total : [],
                total: 0
            },
            financialBalance: {
                start: {},
                end: {}
            },
            orderBy:{
                column: 'created_at',
                direction: 'desc',
            },
            UrlPayment: null,
            UrlDownloadFinanceReport: null,
            officeFinancialBalances: []
        }
    },
    methods:{
        onSelectOffice: function (office) { 
            this.tempOffice = office
            this.moduleFilters.app_offices_id = (office==null)? null: office.id
            this.setOfficeFinancialBalances()
            this.applyFilters()
        },
        onSelectFactory: function (factory) { 
            this.tempFactory = factory
            this.moduleFilters.app_factories_id = (factory==null)? null: factory.id
            this.applyFilters()
        },
        onChangeDateRangeFilterByLocal(dateRange){
            if (dateRange) {
                if (dateRange[0] && dateRange[1]) {
                    const startDate = moment(dateRange[0]).startOf('day')
                    const endDate = moment(dateRange[1]).endOf('day')
                    this.moduleFilters.date_start = this.getDateFromString(startDate, null, this.dateFormat.ymdhis, 'utc') 
                    this.moduleFilters.date_end = this.getDateFromString(endDate, null, this.dateFormat.ymdhis, 'utc') 
                }else{
                    this.setDefaultDateFilter()
                }
            }else{
                this.moduleFilters.date_start = null
                this.moduleFilters.date_end = null
            }
            this.applyFilters()
        },
        setCustomDefaultPagination(){
            this.pagination = {
                state: {
                    per_page:  5000, // required
                    current_page: 1, // required
                    last_page: 1, // required
                    from: 1,
                    to: 5000 // required
                },
                options: {
                    alwaysShowPrevNext: true
                }
            };
            
        },
        loadData: function loadData(resetCurrentPage) {
            var _this6 = this;
            _this6.setCustomDefaultPagination()

            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction
                }
            };

            if (resetCurrentPage === true) {
                options.params.page = 1;
            }

            Object.assign(options.params, this.filters);

            axios.get(this.url, options).then(function (response) {
                _this6.countResult = response.data.count;
                const { calculated } = response.data
                _this6.calculated = {
                    financial_total : calculated.financial_total||[],
                    total: calculated.total||0
                };
                _this6.financialBalance = response.data.financialBalance;
                _this6.buildUrlPayment()
                _this6.buildUrlDownloadFinanceReport()
                return _this6.populateCurrentStateAndData(response.data.data);
            }, function (error) {
                // TODO handle error
            });
        },
        setDefaultSelectOffice: function (office) { 
            this.tempOffice = office
            this.moduleFilters.app_offices_id = (office==null)? null: office.id
        },
        setDefaultDateFilter(){
            const startDate = moment(new Date()).startOf('day')
            const endDate = moment(new Date()).endOf('day')
            this.moduleFilters.date_start = this.getDateFromString(startDate, null, this.dateFormat.ymdhis, 'utc') 
            this.moduleFilters.date_end = this.getDateFromString(endDate, null, this.dateFormat.ymdhis, 'utc') 

        },
        buildUrlPayment(){
            const baseUrl = this.urlDownloadPayment
            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                }
            };
            // console.log(this.filterObject(this.filters, function (val, key) { return val !== null }))
            Object.assign(options.params, this.filterObject(this.filters, function (val, key) { return val !== null }));
            const queryString = '?' + new URLSearchParams(options.params).toString();
            this.UrlPayment = baseUrl+queryString;
        },
        buildUrlDownloadFinanceReport(){
            const baseUrl = this.url
            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                    action: 'to-excel',
                }
            };
            
            Object.assign(options.params, this.filterObject(this.filters, function (val, key) { return val !== null }));
            const queryString = '?' + new URLSearchParams(options.params).toString();
            this.UrlDownloadFinanceReport = baseUrl+queryString;
        },
        setDefaultSelectedBalanceCash(){
            for (let index = 0; index < this.officeFinancialBalances.length; index++) {
                const element = this.officeFinancialBalances[index];
                if (element.source_type=='CASH') {
                    this.moduleFilters.source_balance_id = element.id
                }
            }
        },
        setOfficeFinancialBalances (isEmpty) { 
            if (!this.isAdmin) {
                this.officeFinancialBalances = this.financialBalances[this.appOfficesId]||[]
                this.setDefaultSelectedBalanceCash()
                return
            }
            isEmpty = isEmpty || false
            if (isEmpty) {
                this.officeFinancialBalances = []    
            }else{
                this.officeFinancialBalances = this.financialBalances[this.moduleFilters.app_offices_id]||[]
            }
            this.setDefaultSelectedBalanceCash()
         },
    },
    computed: {
        isValidDownload () { 
            return Object.keys(this.financialBalance.start).length>0 && Object.keys(this.financialBalance.end).length>0
        }
    },
    mounted: function () {  
        
        this.moduleFilters.app_offices_id = this.moduleFilters.app_offices_id
        this.setDefaultSelectOffice(this.userOffice)
        this.setCustomDefaultPagination()
        this.setDefaultDateFilter()
        this.setOfficeFinancialBalances()
        this.applyFilters()
    },
    created: function created() {
        if (this.financialBalanceProp != null) {
            this.financialBalance = this.financialBalanceProp
        } 

        if (this.data != null) {
            // this.populateCurrentStateAndData(this.data);
        } else {
            // this.loadData();
        }

        var _this = this;
        // setInterval(function () {
        //     _this.now = (0, _moment2.default)().tz(_this.timezone).format('YYYY-MM-DD HH:mm:ss');
        // }, 1000);
    },
});